export function floatingButton($) {
    $(".floating-button").on("click", function () {
        var target = $(this).data("target");
        console.log(target);
        $(this).toggleClass("active");
        $(target).find(".floating-content-box").toggleClass("active");
    });

    var lastScrollTop = 0;
    var $floatingButtons = $('.floating-buttons-container');

    // Show buttons initially
    $floatingButtons.show();

    $(window).on('scroll', function () {
        var currentScrollTop = $(this).scrollTop();

        if (currentScrollTop > lastScrollTop) {
            // Scrolling down: hide buttons with bounce out effect
            if (!$floatingButtons.hasClass('hidden') && !$floatingButtons.hasClass('bounce-out')) {
                $floatingButtons.addClass('bounce-out').removeClass('bounce-in');
                setTimeout(function () {
                    $floatingButtons.addClass('hidden').removeClass('bounce-out');
                }, 600); // 600ms matches the bounceOut animation duration
            }
        } else {
            // Scrolling up: show buttons with bounce-in effect
            if ($floatingButtons.hasClass('hidden')) {
                $floatingButtons.removeClass('hidden').addClass('bounce-in');
            }
        }

        lastScrollTop = currentScrollTop;
    });
}